/**
 * @fileoverview Parts list: tile counts per (size, color) for one sheet.
 * @module partsList
 */
export const UNPAINTED_LABEL = 'Unpainted';

/**
 * @param {Object} pattern
 * @param {Object<string, {name: string, hex: string}>} colors
 * @returns {Array<{size: string, colorName: string, hex: string|null, count: number}>}
 *   Sorted by size order in `pattern.sizes`, then by count descending.
 */
export function buildPartsList(pattern, colors) {
    if (!pattern) return [];
    const rows = new Map();
    for (const t of pattern.tiles) {
        const c = colors?.[t.id];
        const colorName = c?.name || UNPAINTED_LABEL;
        const key = `${t.size}|${colorName}`;
        const row = rows.get(key) || { size: t.size, colorName, hex: c?.hex || null, count: 0 };
        row.count += 1;
        rows.set(key, row);
    }
    const sizeOrder = new Map((pattern.sizes || []).map((s, i) => [s, i]));
    return [...rows.values()].sort(
        (a, b) =>
            (sizeOrder.get(a.size) ?? 99) - (sizeOrder.get(b.size) ?? 99) ||
            b.count - a.count ||
            a.colorName.localeCompare(b.colorName),
    );
}
